import React from "react";
import _ from "lodash";
import glamorous from "glamorous";
import ReactTable from "react-table";
import { Button } from "react-bootstrap";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import Plus from "react-icons/lib/md/add";
import Loader from "react-loader";

import OrganizationsModal from "./OrganizationsModal";
import SearchBar from "../../vendor/signal-widgets/components/search-bar";
import { getColumns } from "./OrganizationsColumns";
import { datatableThStyles, styleify } from "../../styles/table-styles";
import Colors from "../../styles/colors";
//import { fetchOrganizationTypes } from "./OrganizationsState";

export const ModalMode = {
  CREATE: "CREATE",
  UPDATE: "UPDATE",
  DELETE: "DELETE"
};

export const OrganizationNames = {
  SHIPPER: "Shipper",
  CARRIER: "Carrier",
  SUPPLIER: "Supplier",
  THIRD_PARTY_LOGISTIC: "ThirdParty"
};

export const OrganizationTypes = [
  {
    id: 0,
    profile_id: 1,
    name: OrganizationNames.SHIPPER
  },
  {
    id: 1,
    profile_id: 2,
    name: OrganizationNames.CARRIER
  },
  {
    id: 2,
    profile_id: 5,
    name: OrganizationNames.SUPPLIER
  },
  {
    id: 3,
    profile_id: 6,
    name: OrganizationNames.THIRD_PARTY_LOGISTIC
  }
];

const Section = glamorous.section({
  display: "flex",
  flex: 1,
  flexDirection: "column",
  justifyContent: "space-between",
  padding: "1em"
});

export default class OrganizationsView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchStr: "",
      tabIndex: 0,
      organization: null,
      organizationName: "",
      modalMode: ModalMode.CREATE,
      showOrganizationsModal: false
    };

    this.rowActionHandler = this.rowActionHandler.bind(this);
  }

  componentWillMount() {
    /*const { fetchOrganizations } = this.props;
    fetchOrganizations();
    fetchOrganizationTypes();*/
  }

  rowActionHandler(action, val) {
    switch (action) {
      case "UPDATE":
        this.setState({
          modalMode: ModalMode.UPDATE,
          organization: val,
          showOrganizationsModal: true,
          organizationName: ""
        });
        break;

      case "DELETE":
        //TODO: delete org
        this.setState({
          modalMode: ModalMode.DELETE,
          organization: val,
          showOrganizationsModal: true,
          organizationName: ""
        });
        break;

      case "CANCEL":
        this.setState({
          modalMode: ModalMode.CREATE,
          organization: null,
          showOrganizationsModal: false,
          organizationName: ""
        });
        break;

      default:
        break;
    }
  }

  getTabPanel(organizationType, organizations, searchStr) {
    // remove deleted organizations
    organizations = _.filter(organizations, function(o) {
      return !o.deleted_at;
    });
    const columns = getColumns(organizationType, this.rowActionHandler);

    const tableTrProps = () => {
      return {
        style: { cursor: "pointer" }
      };
    };

    return (
      <TabPanel>
        <glamorous.Div
          css={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            marginTop: "1em"
          }}
        >
          <SearchBar
            placeholder={"Search for organization"}
            searchStr={searchStr}
            eventHandler={(searchStr, type) => this.setState({ searchStr })}
          />
          <Button
            style={{
              backgroundColor: Colors.highlight.GREEN,
              color: "white",
              fontWeight: "300",
              height: "3em",
              marginLeft: "0.5em"
            }}
            onClick={() =>
              this.setState({
                showOrganizationsModal: true,
                modalMode: ModalMode.CREATE,
                organizationName: "",
                organization: null
              })
            }
          >
            <Plus size="2em" /> Add New Organization
          </Button>
        </glamorous.Div>

        <ReactTable
          data={organizations}
          columns={columns}
          getTheadThProps={styleify(datatableThStyles)}
          getTrProps={tableTrProps}
        />
      </TabPanel>
    );
  }

  getTabOrganizations(tabIndex, organizations) {
    switch (tabIndex) {
      case 0:
        return _.filter(organizations, function(o) {
          return o.org_type === OrganizationNames.SHIPPER && !o.deleted_at;
        });
      case 1:
        return _.filter(organizations, function(o) {
          return o.org_type === OrganizationNames.CARRIER && !o.deleted_at;
        });
      case 2:
        return _.filter(organizations, function(o) {
          return o.org_type === OrganizationNames.SUPPLIER && !o.deleted_at;
        });
      case 3:
        return _.filter(organizations, function(o) {
          return (
            o.org_type === OrganizationNames.THIRD_PARTY_LOGISTIC &&
            !o.deleted_at
          );
        });
      default:
        return [];
    }
  }

  render() {
    const {
      searchStr,
      tabIndex,
      showOrganizationsModal,
      modalMode,
      organization,
      organizationName
    } = this.state;
    const { isOrganizationsLoaded, organizations } = this.props;

    var shippers = _.filter(organizations, function(o) {
      return o.org_type === OrganizationNames.SHIPPER && !o.deleted_at;
    });
    var carriers = _.filter(organizations, function(o) {
      return o.org_type === OrganizationNames.CARRIER && !o.deleted_at;
    });
    var suppliers = _.filter(organizations, function(o) {
      return o.org_type === OrganizationNames.SUPPLIER && !o.deleted_at;
    });
    var thirdPartLogistics = _.filter(organizations, function(o) {
      return (
        o.org_type === OrganizationNames.THIRD_PARTY_LOGISTIC && !o.deleted_at
      );
    });

    let tabOrganizations = this.getTabOrganizations(tabIndex, organizations);
    tabOrganizations = _.sortBy(tabOrganizations, "org_name");
    const filteredOrganizations = searchStr
      ? tabOrganizations.filter(o => {
          return (
            (o.org_name &&
              o.org_name.toLowerCase().includes(searchStr.toLowerCase())) ||
            (o.fv_id && o.fv_id.toLowerCase().includes(searchStr.toLowerCase()))
          );
        })
      : tabOrganizations;

    const linkStyle = {
      fontStyle: "italic",
      textDecoration: "underline",
      marginLeft: "-25px",
      color: "#acb5be",
      fontSize: 12
    };

    const shippersTabPanel = this.getTabPanel(
      OrganizationNames.SHIPPER,
      filteredOrganizations,
      searchStr
    );
    const carriersTabPanel = this.getTabPanel(
      OrganizationNames.CARRIER,
      filteredOrganizations,
      searchStr
    );
    const suppliersTabPanel = this.getTabPanel(
      OrganizationNames.SUPPLIER,
      filteredOrganizations,
      searchStr
    );
    const thirdPartyLogisticsTabPanel = this.getTabPanel(
      OrganizationNames.THIRD_PARTY_LOGISTIC,
      filteredOrganizations,
      searchStr
    );

    const tabs = (
      <TabList
        style={{ display: "flex", flexDirection: "row", marginBottom: 0 }}
      >
        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em"
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "2em",
              color: Colors.background.GRAY_BLUE
            }}
          >
            <glamorous.Div
              css={{
                fontWeight: "bold",
                fontSize: "1.3em",
                color: tabIndex === 0 ? Colors.highlight.GREEN : "black",
                marginRight: "0.25em"
              }}
            >
              {`${shippers.length}`}
            </glamorous.Div>
            <glamorous.Div
              css={{
                marginTop: "1px",
                fontStyle: "italic",
                fontWeight: "bold",
                color: tabIndex === 0 ? "black" : "#acb5be"
              }}
            >
              Shippers
              <p>
                <a
                  style={linkStyle}
                  onClick={() =>
                    this.setState({
                      showOrganizationsModal: true,
                      modalMode: ModalMode.CREATE,
                      organization: null,
                      organizationName: OrganizationNames.SHIPPER
                    })
                  }
                >
                  Add New Shipper
                </a>
              </p>
            </glamorous.Div>
          </glamorous.Div>
        </Tab>

        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em"
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "2em",
              color: Colors.background.GRAY_BLUE
            }}
          >
            <glamorous.Div
              css={{
                fontWeight: "bold",
                fontSize: "1.3em",
                color: tabIndex === 1 ? Colors.highlight.GREEN : "black",
                marginRight: "0.25em"
              }}
            >
              {`${carriers.length}`}
            </glamorous.Div>
            <glamorous.Div
              css={{
                marginTop: "1px",
                fontStyle: "italic",
                fontWeight: "bold",
                color: tabIndex === 1 ? "black" : "#acb5be"
              }}
            >
              Carriers
              <p>
                <a
                  style={linkStyle}
                  onClick={() =>
                    this.setState({
                      showOrganizationsModal: true,
                      modalMode: ModalMode.CREATE,
                      organization: null,
                      organizationName: OrganizationNames.CARRIER
                    })
                  }
                >
                  Add New Carrier
                </a>
              </p>
            </glamorous.Div>
          </glamorous.Div>
        </Tab>

        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em"
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "2em",
              color: Colors.background.GRAY_BLUE
            }}
          >
            <glamorous.Div
              css={{
                fontWeight: "bold",
                fontSize: "1.3em",
                color: tabIndex === 2 ? Colors.highlight.GREEN : "black",
                marginRight: "0.25em"
              }}
            >
              {`${suppliers.length}`}
            </glamorous.Div>
            <glamorous.Div
              css={{
                marginTop: "1px",
                fontStyle: "italic",
                fontWeight: "bold",
                color: tabIndex === 2 ? "black" : "#acb5be"
              }}
            >
              Suppliers
              <p>
                <a
                  style={linkStyle}
                  onClick={() =>
                    this.setState({
                      showOrganizationsModal: true,
                      modalMode: ModalMode.CREATE,
                      organization: null,
                      organizationName: OrganizationNames.SUPPLIER
                    })
                  }
                >
                  Add New Supplier
                </a>
              </p>
            </glamorous.Div>
          </glamorous.Div>
        </Tab>

        <Tab
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "space-around",
            padding: "0.5em"
          }}
        >
          <glamorous.Div
            css={{
              display: "flex",
              flexDirection: "row",
              lineHeight: "2em",
              color: Colors.background.GRAY_BLUE
            }}
          >
            <glamorous.Div
              css={{
                fontWeight: "bold",
                fontSize: "1.3em",
                color: tabIndex === 3 ? Colors.highlight.GREEN : "black",
                marginRight: "0.25em"
              }}
            >
              {`${thirdPartLogistics.length}`}
            </glamorous.Div>
            <glamorous.Div
              css={{
                marginTop: "1px",
                fontStyle: "italic",
                fontWeight: "bold",
                color: tabIndex === 3 ? "black" : "#acb5be"
              }}
            >
              Third-Party
              <p>
                <a
                  style={linkStyle}
                  onClick={() =>
                    this.setState({
                      showOrganizationsModal: true,
                      modalMode: ModalMode.CREATE,
                      organization: null,
                      organizationName: OrganizationNames.THIRD_PARTY_LOGISTIC
                    })
                  }
                >
                  Add New Third-Party
                </a>
              </p>
            </glamorous.Div>
          </glamorous.Div>
        </Tab>
      </TabList>
    );

    return (
      <Section>
        <Loader loaded={isOrganizationsLoaded} />
        <Tabs onSelect={tabIndex => this.setState({ tabIndex })}>
          {tabs}
          {shippersTabPanel}
          {carriersTabPanel}
          {suppliersTabPanel}
          {thirdPartyLogisticsTabPanel}
        </Tabs>
        <OrganizationsModal
          show={showOrganizationsModal}
          hide={() =>
            this.setState({
              showOrganizationsModal: false,
              organizationName: ""
            })
          }
          modalMode={modalMode}
          organization={organization}
          organizationName={organizationName}
        />
      </Section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/organizations/OrganizationsView.js